import { useMemo } from 'react';

const useYearList = (lowerYear: number, upperYear?: number) => {
  return useMemo(() => {
    let year = upperYear || new Date().getFullYear();
    const yearArray: number[] = [];
    while (year >= lowerYear) {
      yearArray.push(year);
      year--;
    }
    return yearArray;
  }, [lowerYear, upperYear]);
};

export default useYearList;
